import { render, staticRenderFns } from "./Recomendacoes.vue?vue&type=template&id=110e3c5f"
import script from "./Recomendacoes.vue?vue&type=script&lang=js"
export * from "./Recomendacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports